import { useSelector } from "../../store";
import {
  useGetEventVideoGroups,
  useGetEventVideoGroupsSets,
} from "./videojsComponent/multiAngle/useVideoGroupsSet";

import type { EventVideo } from "@spwn/types/firebase/firestore";

/**
 * 現在視聴中のビデオが属するVideoGroupsSet以外のVideoGroupsSetsのメインビデオのリストを取得する
 */
export const useGetMainVideosOfVideoGroupsSetsWithoutCurrentSets = (
  currentVideoId: string,
  eventVideoList: EventVideo[]
): EventVideo[] => {
  const eventVideoMap = useSelector((state) => state.streaming.eventVideoMap);
  const { data: videoGroups = {} } = useGetEventVideoGroups(eventVideoMap);
  const { data: videoGroupsSets = {} } =
    useGetEventVideoGroupsSets(videoGroups);

  const currentVideo = eventVideoMap
    ? eventVideoMap[currentVideoId]
    : undefined;

  const currentVideoGroups = currentVideo?.videoGroupRef?.id
    ? videoGroups[currentVideo?.videoGroupRef?.id]
    : undefined;

  const currentVideoGroupsSetId = currentVideoGroups?.videoGroupsSetRef.id;

  // videoGroupsSets は docId をキーに持つ Record なので、キーがそのまま set の識別子。
  const videoGroupsSetsList = Object.entries(videoGroupsSets).flatMap(
    ([setId, set]) => {
      if (currentVideoGroupsSetId === setId) {
        return [];
      }

      const mainVideoId = set.mainVideoRef.id;

      const mainVideo = eventVideoList.find(
        (video) => video._id === mainVideoId
      );

      if (mainVideo === undefined) {
        return [];
      }

      return {
        ...mainVideo,
        name: set.name,
      };
    }
  );

  return videoGroupsSetsList;
};
